// 📁 components/StreetView/StreetViewModal.jsx
import React, { useEffect, useCallback } from "react";
import { useGoogleStreetView } from "../../hooks/useGoogleStreetView";
import { useDeviceDetection } from "../../hooks/useDeviceDetection";
//import { useModalBehavior } from "../../hooks/useModalBehavior";
import { useEscapeKey } from "../../hooks/useEscapeKey";
import StreetViewHeader from "./StreetViewHeader";
import StreetViewContent from "./StreetViewContent";
import "./StreetViewModal.css";
import { hexToRgba } from "../../utils/couleurs.js";


const StreetViewModal = ({
  isOpen,
  onClose,
  id = null,
  nyme = null,
  adress = null,
  bgColor = null,
  heading = 0,
  pitch = 0,
  zoom = 1,
  typoloColor = "#fff",
  coords = { lat: null, lng: null },
}) => {
  const { isMobile } = useDeviceDetection();

  const {
    panoramaRef,
    loading,
    error,
    isAvailable,
    address,
    initializePanorama,
    cleanupPanorama,
  } = useGoogleStreetView(coords, heading, pitch, zoom, isMobile);

  // Initialisation
  useEffect(() => {
    if (!isOpen /*|| !coords?.lat || !coords?.lng*/) {
      cleanupPanorama();
      return;
    }

    initializePanorama();
    return cleanupPanorama;
  }, [isOpen, /*coords,*/ initializePanorama, cleanupPanorama]);

  // Gestion clavier : ESC pour fermer
  //useModalBehavior(isOpen, onClose,  {closeOnEscape: true,lockScroll: true });
  useEscapeKey(onClose, isOpen);

  // Ouvrir dans Google Maps
  const openInGoogleMaps = useCallback(() => {
    const url = `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${coords.lat},${coords.lng}&heading=${heading}&pitch=${pitch}`;
    window.open(url, "_blank", "noopener,noreferrer");
  }, [coords, heading, pitch]);

  if (!isOpen) return null;

  //console.log("nyme", nyme);
  //console.log("typoloColor", typoloColor);
  return (
    <div
      className="streetview-overlay"
      //onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="streetview-title"
      style={{ backgroundColor: hexToRgba(typoloColor, 0.325) }}
    >
      <div className="streetview-modal" onClick={(e) => e.stopPropagation()}>
        <StreetViewHeader
          id={id}
          nyme={nyme}
          imageAdress={adress}
          address={address}
          bgColor={typoloColor}
          onOpenInGoogleMaps={openInGoogleMaps}
          onClose={onClose}
        />

        <StreetViewContent
          loading={loading}
          error={error}
          isAvailable={isAvailable}
          panoramaRef={panoramaRef}
          onOpenInGoogleMaps={openInGoogleMaps}
        />

        <div className="streetview-footer">
          <small>
            Powered by{" "}
            <a
              href="https://www.google.com/permissions/geoguidelines/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Street View
            </a>{" "}
            | © {new Date().getFullYear()} Google
          </small>
        </div>
      </div>
    </div>
  );
};

export default StreetViewModal;
